var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { resourceNames, UZ } from "../../constants/accountResourceNames";
import { FormattedMessage, defineMessages } from "react-intl";
import { withdrawData as withdrawDataAction } from "../../actions/withdraw/creators/withdraw";
import { fetchBalance as fetchBalanceAction } from "../../actions/creators/balance";
var POLL_INTERVAL_MS = 20000;
var TERMINAL_STATES = [4, 5];
var messages = defineMessages({
    state_label: {
        id: "withdrawal.withdraw_order_state",
        defaultMessage: "Статус заявки"
    },
    state_1: {
        id: "withdrawal.withdraw_order_state_1",
        defaultMessage: "В обработке"
    },
    state_2: {
        id: "withdrawal.withdraw_order_state_2",
        defaultMessage: "Готова к выплате"
    },
    state_3: {
        id: "withdrawal.withdraw_order_state_3",
        defaultMessage: "Готова к выплате"
    },
    state_4: {
        id: "withdrawal.withdraw_order_state_4",
        defaultMessage: "Выполнена"
    },
    state_5: {
        id: "withdrawal.withdraw_order_state_5",
        defaultMessage: "Отменена"
    }
});
var withdrawalInProcessMsg = {
    id: "withdrawal_cancel_withdrawal_in_process",
    defaultMessage: "Заявка в обработке. Отмена заявки невозможна"
};
var withdrawalInternalErrorMsg = {
    id: "withdrawal_cancel_internal_error",
    defaultMessage: "Внутренняя ошибка во время выполнения запроса. Повторите позже"
};
var errors = defineMessages({
    "-1": {
        id: "withdrawal_cancel_already_canceled",
        defaultMessage: "Заявка на снятие уже отменена"
    },
    "-2": {
        id: "withdrawal_cancel_already_paid",
        defaultMessage: "Заявка на снятие уже выплачена"
    },
    "-3": {
        id: "withdrawal_cancel_already_refund",
        defaultMessage: "Возврат по заявке уже совершен. Отмена заявки невозможна"
    },
    "-4": withdrawalInProcessMsg,
    "-5": {
        id: "withdrawal_cancel_withdrawal_changed",
        defaultMessage: "Данные по заявке изменились. Отмена заявки невозможна"
    },
    "-6": withdrawalInProcessMsg,
    "-400": withdrawalInProcessMsg,
    "-100": withdrawalInternalErrorMsg,
    "-1000": withdrawalInternalErrorMsg
});
var formatNumber = function (num) { return Intl.NumberFormat("ru").format(num); };
var Active = /** @class */ (function (_super) {
    __extends(Active, _super);
    function Active() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pollInterval = null;
        _this.handleTerminalState = function (withdrawal) {
            if (!withdrawal || !TERMINAL_STATES.includes(withdrawal.State)) {
                return;
            }
            _this.props.fetchBalanceAction();
        };
        _this.startPolling = function () {
            var withdrawal = _this.props.withdrawal;
            if (!withdrawal || TERMINAL_STATES.includes(withdrawal.State)) {
                return;
            }
            _this.pollInterval = setInterval(function () {
                _this.props.withdrawDataAction();
            }, POLL_INTERVAL_MS);
        };
        _this.stopPolling = function () {
            if (_this.pollInterval) {
                clearInterval(_this.pollInterval);
                _this.pollInterval = null;
            }
        };
        _this.renderStatusBanner = function () {
            var withdrawal = _this.props.withdrawal;
            var amount = withdrawal.TargetAmount || withdrawal.SourceAmount;
            var currency = resourceNames[withdrawal.ResourceId] ||
                resourceNames[withdrawal.TargetResourceId] ||
                "UZS";
            if (withdrawal.State === 4) {
                return (_jsx("div", __assign({ className: "withdrawal-success", style: { marginBottom: "15px" } }, { children: _jsx(FormattedMessage, { id: "withdraw.expay.status_success", values: { amount: formatNumber(amount), currency: currency } }) })));
            }
            if (withdrawal.State === 5) {
                return (_jsx("div", __assign({ className: "withdrawal-error", style: { marginBottom: "15px" } }, { children: _jsx(FormattedMessage, { id: "withdraw.expay.status_error" }) })));
            }
            return null;
        };
        return _this;
    }
    Active.prototype.componentDidMount = function () {
        this.startPolling();
        this.handleTerminalState(this.props.withdrawal);
    };
    Active.prototype.componentDidUpdate = function (prevProps) {
        var prevState = prevProps.withdrawal && prevProps.withdrawal.State;
        var nextState = this.props.withdrawal && this.props.withdrawal.State;
        if (prevState !== nextState) {
            this.handleTerminalState(this.props.withdrawal);
        }
        if (TERMINAL_STATES.includes(nextState) &&
            this.pollInterval) {
            this.stopPolling();
        }
    };
    Active.prototype.componentWillUnmount = function () {
        this.stopPolling();
    };
    Active.prototype.render = function () {
        var _a = this.props, withdrawal = _a.withdrawal, cancel = _a.cancel, cancelStatus = _a.cancelStatus;
        var salepointAddress = withdrawal.Details && withdrawal.Details.SalepointAddress !== undefined
            ? withdrawal.Details.SalepointAddress
            : null;
        var details = withdrawal.Details || {};
        var code = details.Code !== undefined ? details.Code : null;
        var cardNumber = details.CardNumber || details.MaskedCard || details.Card || null;
        var currency = resourceNames[withdrawal.SourceResourceId] ||
            resourceNames[UZ];
        var amountValue = withdrawal.SourceAmount;
        var amount = "".concat(formatNumber(amountValue), " ").concat(currency);
        var statusMsg = messages["state_" + withdrawal.State];
        var wallet = details.Wallet;
        var errorMsg = errors[cancelStatus];
        var createdDate = moment(withdrawal.IssueDate)
            .tz("Asia/Bishkek")
            .format("DD.MM.YYYY, HH:mm");
        var canCancel = withdrawal.State === 1;
        return (_jsxs("div", __assign({ className: "block withdraw-form" }, { children: [this.renderStatusBanner(), cancelStatus !== undefined && errorMsg && (_jsx("div", __assign({ className: "withdrawal-error" }, { children: _jsx(FormattedMessage, __assign({}, errorMsg)) }))), _jsxs("div", __assign({ className: "body" }, { children: [_jsxs("div", __assign({ className: "forms" }, { children: [_jsxs("div", __assign({ className: "form-body" }, { children: [cardNumber && (_jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.card_number" }) }), _jsx("div", __assign({ className: "info" }, { children: cardNumber }))] }))), _jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.application_number" }) }), _jsx("div", __assign({ className: "info" }, { children: withdrawal.WithdrawalId }))] })), _jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.date_created" }) }), _jsx("div", __assign({ className: "info" }, { children: createdDate }))] })), _jsxs("div", __assign({ className: "input" }, { children: [salepointAddress && (_jsxs("div", { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.cashbox" }) }), _jsx("div", __assign({ className: "info" }, { children: salepointAddress }))] })), code && (_jsxs("div", __assign({ style: { margin: "15px 0" } }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.code" }) }), _jsx("div", __assign({ className: "info" }, { children: code }))] }))), _jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.sum" }) }), _jsx("div", __assign({ className: "info" }, { children: amount }))] })), withdrawal.Rate && (_jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.rate" }) }), _jsx("div", __assign({ className: "info" }, { children: withdrawal.Rate }))] }))), details.Commission !== undefined && (_jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.commission" }) }), _jsxs("div", __assign({ className: "info" }, { children: [formatNumber(details.Commission), " ", currency] }))] }))), wallet && (_jsxs("div", __assign({ className: "input" }, { children: [_jsx("label", { children: _jsx(FormattedMessage, { id: "withdraw.wallet" }) }), _jsx("div", __assign({ className: "info" }, { children: wallet }))] }))), _jsxs("div", __assign({ className: "input" }, { children: [_jsx(FormattedMessage, __assign({}, messages.state_label, { children: function (m) { return _jsx("label", { children: m }); } })), _jsx(FormattedMessage, __assign({}, statusMsg, { children: function (m) { return _jsx("div", __assign({ className: "info" }, { children: m })); } }))] }))] })), _jsx("div", { className: "form-bottom" })] })), canCancel ? (_jsx("div", __assign({ className: "cancel-withdraw" }, { children: _jsx("a", __assign({ id: "cancel_order", href: "#", onClick: cancel }, { children: _jsx(FormattedMessage, { id: "withdraw.cancel" }) })) }))) : (withdrawal.State > 1 &&
                            withdrawal.State < 5 && (_jsx("div", __assign({ className: "withdrawal-error", style: { marginTop: "15px" } }, { children: _jsx(FormattedMessage, __assign({}, withdrawalInProcessMsg)) }))))] }))] })));
    };
    return Active;
}(React.Component));
Active.propTypes = {
    withdrawal: PropTypes.object.isRequired,
    cancel: PropTypes.func.isRequired,
    cancelStatus: PropTypes.any,
    withdrawDataAction: PropTypes.func.isRequired,
    fetchBalanceAction: PropTypes.func.isRequired
};
var mapDispatchToProps = function (dispatch) {
    return bindActionCreators({
        withdrawDataAction: withdrawDataAction,
        fetchBalanceAction: fetchBalanceAction
    }, dispatch);
};
export default connect(null, mapDispatchToProps)(Active);



// WEBPACK FOOTER //
// ./src/components/withdraw/Active.jsx